export const NEWSFEED_CARD_PADDING = 5

export const DEFAULT_NEWSFEED_IMAGE_HEIGHT = 250

export const GROUP_MEDIA_TIME_RANGE_MINS = 15

export const BUBBLE_AVATAR_SIZE = 36
